import * as BiomeDetailsActions from '~app/actions/biomeDetails';
import makeReducer from '~app/core/makeReducer';

const initialState = {
  locationInfos: [],
};

function showBiomeDetails(state, {locationInfos}) {
  return {
    ...state,
    locationInfos,
  };
}

function clearBiomeDetails(state) {
  return {
    ...state,
    locationInfos: [],
  };
}

const ACTION_HANDLERS = {
  [BiomeDetailsActions.SHOW_BIOME_DETAILS]: showBiomeDetails,
  [BiomeDetailsActions.CLEAR_BIOME_DETAILS]: clearBiomeDetails,
};

export default makeReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/store/biomeDetailsReducer.js